class GoToStores {
  constructor(element) {
    this.element = element;

    this.bindEvents();
  }

  /**
   * Bind all events
   */
  bindEvents() {
    this.element.addEventListener('click', (event) => this.handleButtonClick(event));
  }

  handleButtonClick(event) {
    event.preventDefault();
    window.location.href = this.element.getAttribute('href');
  }
}

export default GoToStores;
